import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import useCountries from '../../hooks/useCountries';
import { resolveCountryIso } from '../../utils/addressCountry';

/**
 * Country Autocomplete backed by SEED Data → Countries (GET /utils/countries).
 * Stores ISO-2 code (e.g. US) by default.
 */
export default function CountrySelectField({
  label = 'Country',
  value,
  onChange,
  disabled,
  required,
  fullWidth = true,
  margin = 'normal',
  helperText,
  storeLabel = false,
  size = 'medium',
}) {
  const { countries, loading } = useCountries();
  const iso = resolveCountryIso(value, countries) || String(value || '').toUpperCase().slice(0, 2);
  const selected =
    countries.find((c) => String(c.code || c.isoCode || '').toUpperCase() === iso) || null;

  return (
    <Autocomplete
      options={countries}
      loading={loading}
      disabled={disabled || (!countries.length && loading)}
      getOptionLabel={(opt) => (typeof opt === 'string' ? opt : opt.label || opt.name || opt.code || '')}
      isOptionEqualToValue={(a, b) =>
        String(a.code || a.isoCode || '') === String(b.code || b.isoCode || '')
      }
      value={selected}
      onChange={(_, opt) => {
        if (!opt) {
          onChange?.('');
          return;
        }
        onChange?.(storeLabel ? opt.label || opt.name || '' : opt.code || opt.isoCode || '');
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          required={required}
          fullWidth={fullWidth}
          margin={margin}
          size={size}
          helperText={helperText}
        />
      )}
    />
  );
}
